// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/conversion/v1/conversion_api.proto (package gdx.gateway.web.conversion.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Conversion } from "./conversion_pb.js";

/**
 * @generated from message gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest
 */
export class GetFacebookTrackingParamsRequest extends Message<GetFacebookTrackingParamsRequest> {
  /**
   * @generated from field: gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest.RoutingParams params = 1;
   */
  params?: GetFacebookTrackingParamsRequest_RoutingParams;

  constructor(data?: PartialMessage<GetFacebookTrackingParamsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "params", kind: "message", T: GetFacebookTrackingParamsRequest_RoutingParams },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFacebookTrackingParamsRequest {
    return new GetFacebookTrackingParamsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsRequest {
    return new GetFacebookTrackingParamsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsRequest {
    return new GetFacebookTrackingParamsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFacebookTrackingParamsRequest | PlainMessage<GetFacebookTrackingParamsRequest> | undefined, b: GetFacebookTrackingParamsRequest | PlainMessage<GetFacebookTrackingParamsRequest> | undefined): boolean {
    return proto3.util.equals(GetFacebookTrackingParamsRequest, a, b);
  }
}

/**
 * Describes required params to determine tracking for unregistered user. Is ignored after auth.
 *
 * @generated from message gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest.RoutingParams
 */
export class GetFacebookTrackingParamsRequest_RoutingParams extends Message<GetFacebookTrackingParamsRequest_RoutingParams> {
  /**
   * @generated from field: string landing_url = 1;
   */
  landingUrl = "";

  /**
   * @generated from field: int32 mirror_id = 2;
   */
  mirrorId = 0;

  /**
   * @generated from field: gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest.RoutingParams.Gender gender = 3;
   */
  gender = GetFacebookTrackingParamsRequest_RoutingParams_Gender.INVALID;

  constructor(data?: PartialMessage<GetFacebookTrackingParamsRequest_RoutingParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest.RoutingParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mirror_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "gender", kind: "enum", T: proto3.getEnumType(GetFacebookTrackingParamsRequest_RoutingParams_Gender) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFacebookTrackingParamsRequest_RoutingParams {
    return new GetFacebookTrackingParamsRequest_RoutingParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsRequest_RoutingParams {
    return new GetFacebookTrackingParamsRequest_RoutingParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsRequest_RoutingParams {
    return new GetFacebookTrackingParamsRequest_RoutingParams().fromJsonString(jsonString, options);
  }

  static equals(a: GetFacebookTrackingParamsRequest_RoutingParams | PlainMessage<GetFacebookTrackingParamsRequest_RoutingParams> | undefined, b: GetFacebookTrackingParamsRequest_RoutingParams | PlainMessage<GetFacebookTrackingParamsRequest_RoutingParams> | undefined): boolean {
    return proto3.util.equals(GetFacebookTrackingParamsRequest_RoutingParams, a, b);
  }
}

/**
 * Possible values for user gender in profile.
 *
 * @generated from enum gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest.RoutingParams.Gender
 */
export enum GetFacebookTrackingParamsRequest_RoutingParams_Gender {
  /**
   * @generated from enum value: GENDER_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: GENDER_MALE = 1;
   */
  MALE = 1,

  /**
   * @generated from enum value: GENDER_FEMALE = 2;
   */
  FEMALE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(GetFacebookTrackingParamsRequest_RoutingParams_Gender)
proto3.util.setEnumType(GetFacebookTrackingParamsRequest_RoutingParams_Gender, "gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsRequest.RoutingParams.Gender", [
  { no: 0, name: "GENDER_INVALID" },
  { no: 1, name: "GENDER_MALE" },
  { no: 2, name: "GENDER_FEMALE" },
]);

/**
 * @generated from message gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsResponse
 */
export class GetFacebookTrackingParamsResponse extends Message<GetFacebookTrackingParamsResponse> {
  /**
   * @generated from field: string external_id = 1;
   */
  externalId = "";

  /**
   * @generated from field: string em = 2;
   */
  em = "";

  /**
   * @generated from field: string ge = 3;
   */
  ge = "";

  /**
   * @generated from field: string ct = 4;
   */
  ct = "";

  /**
   * @generated from field: string st = 5;
   */
  st = "";

  /**
   * @generated from field: string country = 6;
   */
  country = "";

  /**
   * @generated from field: string db = 7;
   */
  db = "";

  /**
   * @generated from field: string fn = 8;
   */
  fn = "";

  /**
   * @generated from field: string ln = 9;
   */
  ln = "";

  /**
   * @generated from field: string zp = 10;
   */
  zp = "";

  /**
   * @generated from field: gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsResponse.PixelConfig pixel_config = 11;
   */
  pixelConfig?: GetFacebookTrackingParamsResponse_PixelConfig;

  constructor(data?: PartialMessage<GetFacebookTrackingParamsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "em", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ge", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ct", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "st", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "db", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "fn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "ln", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "zp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "pixel_config", kind: "message", T: GetFacebookTrackingParamsResponse_PixelConfig },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFacebookTrackingParamsResponse {
    return new GetFacebookTrackingParamsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsResponse {
    return new GetFacebookTrackingParamsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsResponse {
    return new GetFacebookTrackingParamsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFacebookTrackingParamsResponse | PlainMessage<GetFacebookTrackingParamsResponse> | undefined, b: GetFacebookTrackingParamsResponse | PlainMessage<GetFacebookTrackingParamsResponse> | undefined): boolean {
    return proto3.util.equals(GetFacebookTrackingParamsResponse, a, b);
  }
}

/**
 * Describes pixel config for user.
 *
 * @generated from message gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsResponse.PixelConfig
 */
export class GetFacebookTrackingParamsResponse_PixelConfig extends Message<GetFacebookTrackingParamsResponse_PixelConfig> {
  /**
   * @generated from field: string pixel_id = 1;
   */
  pixelId = "";

  /**
   * e.g. t50, 3dm, etc...
   *
   * @generated from field: string group = 2;
   */
  group = "";

  constructor(data?: PartialMessage<GetFacebookTrackingParamsResponse_PixelConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.GetFacebookTrackingParamsResponse.PixelConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pixel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFacebookTrackingParamsResponse_PixelConfig {
    return new GetFacebookTrackingParamsResponse_PixelConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsResponse_PixelConfig {
    return new GetFacebookTrackingParamsResponse_PixelConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFacebookTrackingParamsResponse_PixelConfig {
    return new GetFacebookTrackingParamsResponse_PixelConfig().fromJsonString(jsonString, options);
  }

  static equals(a: GetFacebookTrackingParamsResponse_PixelConfig | PlainMessage<GetFacebookTrackingParamsResponse_PixelConfig> | undefined, b: GetFacebookTrackingParamsResponse_PixelConfig | PlainMessage<GetFacebookTrackingParamsResponse_PixelConfig> | undefined): boolean {
    return proto3.util.equals(GetFacebookTrackingParamsResponse_PixelConfig, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.conversion.v1.ListUndeliveredConversionsRequest
 */
export class ListUndeliveredConversionsRequest extends Message<ListUndeliveredConversionsRequest> {
  constructor(data?: PartialMessage<ListUndeliveredConversionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.ListUndeliveredConversionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUndeliveredConversionsRequest {
    return new ListUndeliveredConversionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUndeliveredConversionsRequest {
    return new ListUndeliveredConversionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUndeliveredConversionsRequest {
    return new ListUndeliveredConversionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListUndeliveredConversionsRequest | PlainMessage<ListUndeliveredConversionsRequest> | undefined, b: ListUndeliveredConversionsRequest | PlainMessage<ListUndeliveredConversionsRequest> | undefined): boolean {
    return proto3.util.equals(ListUndeliveredConversionsRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.conversion.v1.ListUndeliveredConversionsResponse
 */
export class ListUndeliveredConversionsResponse extends Message<ListUndeliveredConversionsResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.conversion.v1.Conversion conversions = 1;
   */
  conversions: Conversion[] = [];

  constructor(data?: PartialMessage<ListUndeliveredConversionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.ListUndeliveredConversionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversions", kind: "message", T: Conversion, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUndeliveredConversionsResponse {
    return new ListUndeliveredConversionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUndeliveredConversionsResponse {
    return new ListUndeliveredConversionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUndeliveredConversionsResponse {
    return new ListUndeliveredConversionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListUndeliveredConversionsResponse | PlainMessage<ListUndeliveredConversionsResponse> | undefined, b: ListUndeliveredConversionsResponse | PlainMessage<ListUndeliveredConversionsResponse> | undefined): boolean {
    return proto3.util.equals(ListUndeliveredConversionsResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.conversion.v1.UpdateLastDeliveredTimeRequest
 */
export class UpdateLastDeliveredTimeRequest extends Message<UpdateLastDeliveredTimeRequest> {
  /**
   * @generated from field: google.protobuf.Timestamp last_delivered_time = 1;
   */
  lastDeliveredTime?: Timestamp;

  constructor(data?: PartialMessage<UpdateLastDeliveredTimeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.UpdateLastDeliveredTimeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "last_delivered_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateLastDeliveredTimeRequest {
    return new UpdateLastDeliveredTimeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateLastDeliveredTimeRequest {
    return new UpdateLastDeliveredTimeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateLastDeliveredTimeRequest {
    return new UpdateLastDeliveredTimeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateLastDeliveredTimeRequest | PlainMessage<UpdateLastDeliveredTimeRequest> | undefined, b: UpdateLastDeliveredTimeRequest | PlainMessage<UpdateLastDeliveredTimeRequest> | undefined): boolean {
    return proto3.util.equals(UpdateLastDeliveredTimeRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.conversion.v1.UpdateLastDeliveredTimeResponse
 */
export class UpdateLastDeliveredTimeResponse extends Message<UpdateLastDeliveredTimeResponse> {
  constructor(data?: PartialMessage<UpdateLastDeliveredTimeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.conversion.v1.UpdateLastDeliveredTimeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateLastDeliveredTimeResponse {
    return new UpdateLastDeliveredTimeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateLastDeliveredTimeResponse {
    return new UpdateLastDeliveredTimeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateLastDeliveredTimeResponse {
    return new UpdateLastDeliveredTimeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateLastDeliveredTimeResponse | PlainMessage<UpdateLastDeliveredTimeResponse> | undefined, b: UpdateLastDeliveredTimeResponse | PlainMessage<UpdateLastDeliveredTimeResponse> | undefined): boolean {
    return proto3.util.equals(UpdateLastDeliveredTimeResponse, a, b);
  }
}

